import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import Signup_header from "../Register/signup_header";
import { userService } from "../../_services";
import Header from "../After_Login_common/Header";
import Left_Sidebar from "../After_Login_common/Left_Sidebar";
import cartIcon from '../../images/cart.svg';
import CryptoJS from "crypto-js";
import Product from "./product";
import Cart from "./cart";
import "./ecommerce.scss";

const Ecommerce = () => {
    const [shortname, setShortname] = useState('');
    const [fullName, setFullName] = useState('');
    const [accountInfo, setAccountInfo] = useState('');
    const [productsList, setProductsList] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [cartOpen, setCartOpen] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
        setShortname(usernamedata.split(':')[0]);
        setFullName(usernamedata.split(':')[1]);
        setAccountInfo(window.atob(localStorage.getItem('_file_info')));
        //GetProductsList();
        localStorage.setItem('pagename', 'nls-rx-marketplace');
    }, []);

    useEffect(() => {
        if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
            return <Redirect to="/signup" />;
        }
    }, [])

    useEffect(() => {
        const savedCart = localStorage.getItem("cartItems");
        if (savedCart) {
            setCartItems(JSON.parse(savedCart));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem("cartItems", JSON.stringify(cartItems));
    }, [cartItems]);

    useEffect(() => {
        if (cartOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setCartOpen(false);
            }
        };

        const handleClickOutsideZoom = (event) => {
            if (cartOpen && event.target.closest(".cart-sidebar") === null) {
                setCartOpen(false);
            }
        };

        if (cartOpen) {
            document.addEventListener("keydown", handleKeyDown);
            document.addEventListener("mousedown", handleClickOutsideZoom);
        }

        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handleClickOutsideZoom);
        };
    }, [cartOpen]);

    const getUserDetails = () => {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        return { userName: Usermeta_Data.split(':')[0], userId: Usermeta_Data.split(':')[1] };
    };

    const decryptJsonData = (encryptedData) => {
        try {
            const secretKey = CryptoJS.enc.Utf8.parse("PnatspGK*xvyHY77q}Wh?Uf&*we{l0x!");
            const iv = CryptoJS.enc.Utf8.parse("~6#jt_b^#Q=8iXw!");
            const encryptedHex = CryptoJS.enc.Base64.parse(encryptedData);
            const decrypted = CryptoJS.AES.decrypt(
                { ciphertext: encryptedHex },
                secretKey,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            );
            const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedText);
        } catch (err) {
            return null;
        }
    };

    const GetProductsList = () => {
        setLoader(true);
        try {
            const { userName, userId } = getUserDetails();
            userService.MarketPlaceProduct(userName, userId).then((apidata) => {
                if (apidata.status === "success") {
                    const products = JSON.parse(decryptJsonData(apidata.data));
                    setProductsList(products?.ProductsList);
                }
                setLoader(false);
            });
        } catch (error) {
            setLoader(false);
        }
    };

    useEffect(() => {
        GetProductsList();
    }, []);
    //useEffect(() => {
    //    GetProductsList();
    //}, []);

    const addToCart = (product, selectedPrice, selectedSize, selectedPharmacy) => {
        setCartItems((prevCart) => {
            const existingProductIndex = prevCart.findIndex(item => item.ProductID === product.ProductID);

            if (existingProductIndex !== -1) {
                // If product exists, update its details instead of adding a new one
                const updatedCart = [...prevCart];
                updatedCart[existingProductIndex] = { ...updatedCart[existingProductIndex], selectedPrice, selectedSize, selectedPharmacy };
                return updatedCart;
            }

            // If not in cart, add as new item
            return [...prevCart, { ...product, selectedPrice, selectedSize, selectedPharmacy }];
        });
    };

    const deleteCartItem = (productId) => {
        setCartItems((prevCart) => prevCart.filter(item => item.ProductID !== productId))
    };

    const updateCartPrice = (productId, newPrice) => {
        setCartItems((prevCart) =>
            prevCart.map(item =>
                item.ProductID === productId ? { ...item, selectedPrice: newPrice } : item
            )
        );
    };

    const updateProductSize = (productId, newSize) => {
        setCartItems((prevCart) =>
            prevCart.map(item =>
                item.ProductID === productId ? { ...item, selectedSize: newSize } : item
            )
        );
    };

    const updateProductPharmacy = (productId, newPharmacy) => {
        setCartItems((prevCart) =>
            prevCart.map(item =>
                item.ProductID === productId ? { ...item, selectedPharmacy: newPharmacy } : item
            )
        );
    };

    const clearCart = () => {
        setCartItems([])
    }

    return (
        <div className="Dashboard_Area ecommerce-page">
            <Left_Sidebar Activemenu="11" account_info={accountInfo} fullName={fullName} />
            <div className="contentarea">
                <Header shortName={shortname} fullName={fullName} userRole="" />
                <div className="content_sec">
                    <div className="page-header">
                        <div className="page-heading-row">
                            <h2>NLS Rx Marketplace</h2>
                            {loader && <div className="page-loader"></div>}
                        </div>
                        <div className="buttons">
                            <button className="cart-btn" onClick={() => setCartOpen(!cartOpen)}>
                                Cart ({cartItems.length}) <img src={cartIcon} alt="cart" style={{ width: 20, height: 20 }} />
                            </button>
                        </div>
                    </div>
                    <div className="products-container">
                        {productsList && productsList.length ? productsList.map(product => (
                            <Product key={product.ProductID} product={product} addToCart={addToCart} updateCartPrice={updateCartPrice} updateProductSize={updateProductSize} updateProductPharmacy={updateProductPharmacy} cartItems={cartItems} />
                        )) : null}
                    </div>
                </div>

                {/* Cart Sidebar Component */}
                {cartOpen && (
                    <div className="cart-wrapper">
                        <Cart
                            cartItems={cartItems}
                            updateCartPrice={updateCartPrice}
                            updateProductSize={updateProductSize}
                            updateProductPharmacy={updateProductPharmacy}
                            setCartOpen={setCartOpen}
                            deleteCartItem={deleteCartItem}
                            clearCart={clearCart}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Ecommerce;
